import { cn } from "@/lib/utils";

import useMapStore from "@/store/mapStore";
import { AnimatePresence } from "framer-motion";
import { FaEllipsisH } from "react-icons/fa";
import MoreAccordion from "./MoreAccordion";

function MoreButton() {
  const verticalKioskMode = useMapStore((state) => state.verticalKioskMode);
  const activeMenuItem = useMapStore((state) => state.activeMenuItem);
  const kioskScaling = useMapStore((state) => state.kioskScaling);
  const setActiveMenuItem = useMapStore((state) => state.setActiveMenuItem);

  const handleMoreClick = () => {
    setActiveMenuItem("menu");
  };

  if (!verticalKioskMode) {
    return null;
  }

  return (
    <>
      <div
        className={cn(
          "absolute top-[calc(100dvh-130px)] z-[6] cursor-pointer rounded-full bg-white p-3 text-lg text-primary shadow-[0px_1px_6px_3px_rgba(0,0,0,0.5)] group-data-[dir=ltr]:right-5 group-data-[dir=rtl]:left-5 lg:bottom-auto lg:top-10 lg:group-data-[dir=ltr]:right-10 lg:group-data-[dir=rtl]:left-10 kiosk:bottom-[calc(28%+110px)] kiosk:top-auto kiosk:p-[15px] kiosk:text-2xl kiosk:group-data-[dir=ltr]:right-16 kiosk:group-data-[dir=rtl]:left-16",
          !kioskScaling &&
            "kiosk:origin-bottom-right kiosk:scale-150 kiosk:group-data-[dir=ltr]:right-10 kiosk:group-data-[dir=rtl]:left-10",
        )}
        onClick={handleMoreClick}
      >
        <FaEllipsisH />
      </div>
      <AnimatePresence>
        {activeMenuItem === "menu" && <MoreAccordion />}
      </AnimatePresence>
    </>
  );
}

export default MoreButton;
